import '../assets/css/layout.css'
import {Link, useLocation, useNavigate} from "react-router-dom";
import {useEffect, useRef, useState} from "react";
// import api from "../services/api";
// import {get} from "axios";
// import {useRecoilState} from "recoil";
// import {searchTerm, searchType} from "../recoils/recoil";
import {useHeaderLayout} from "../hooks/useHeaderLayout";
import Aside from "./Aside";

/**
 * 공통 사용 헤더
 */
const Header = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const path = location.pathname;

    const type= useRef("school");
    const [term, setTerm] = useState('');

    const [isAsideOpen, setIsAsideOpen] = useState(false);
    const handleOpenAside = () => setIsAsideOpen(true);
    const handleCloseAside = () => setIsAsideOpen(false);
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 1023); // 1023px를 모바일 기준으로 설정
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);

        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    const handleClick = () => {
        if (isMobile) {
            navigate("/");
        }
    };
    // 레이아웃 적용을 위한 변수
    const {
        searchBoxRef,
        searchAreaRef,
        toggleBtnRef,
        handleSearchToggle
    } = useHeaderLayout();

    // 메인 페이지인지
    const isMain = () => {
        return location.pathname === '/'
    }

    // 검색 타입 지정
    const handleType = (e) => {
        type.current = e.target.value;
    }

    // 검색어 지정
    const handleTerm = (e) => {
        setTerm(e.target.value);
    };

    // 검색
    const handleSearch = () => {
        if (term.length > 0) {
            if (type.current === 'person') {
                navigate(`/person_search/${term}`);
            } else if (type.current === 'school') {
                navigate(`/school_search/${term}`);
            }

            // 검색 후 입력창 초기화
            setTerm('');
        }
    };

    const onKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <>
            <header id="header" className={isMain() ? "main" : "sub"}>
                <div className="w-set">
                    <div className="hd-wrap">
                        <h1 className="is-blind">한국교원대학교 교육박물관 한국근대교육사연구센터</h1>
                        <div className="hd-left">
                            <div className="sub-gnb-wrap" onClick={handleClick}>
                                <div className="is-about">
                                    <Link to="/" className="about-link">한국근대교육사연구센터</Link>
                                </div>
                                <p className="gnb-text">한국근대교육의</p>
                                <ul className="sub-gnb">
                                    <li>
                                        <Link to="/person_search" className={path.includes('person_search')?'on':''}>주체<span>사람들</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/school_search" className={path.includes('school_search')?'on':''}>공간<span>환경들</span></Link>
                                    </li>
                                    <li>
                                        <Link to="/biography_about" className={path.includes('biography_about')?'on':''}>경험<span>순간들</span></Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="gnb-wrap">
                            <ul className="gnb">
                                <li>
                                    <a href="https://www.knue.ac.kr/www/index.do" target="_blank" rel="noopener noreferrer"><i
                                        className="school-logo"></i></a>
                                </li>
                                <li>
                                    <a href="https://museum.knue.ac.kr/smain.html" target="_blank" rel="noopener noreferrer">교육박물관</a>
                                </li>
                                <li>
                                    <a href="https://museum.knue.ac.kr/ori_book.brd?shell=/index.shell:131" target="_blank" rel="noopener noreferrer">유물 원문서비스</a>
                                </li>
                                <li>
                                    <Link to="/about" className={path.includes('/about')?'on':''}>한국근대교육사연구센터</Link>
                                </li>
                                <li>
                                    <Link to="/archive" className={path.includes('archive')?'on':''}>아카이브</Link>
                                </li>
                            </ul>
                        </div>
                        <div className="hd-utils">
                            <div className="school-wrap hide-pc">
                                <a href="https://www.knue.ac.kr/www/index.do" target="_blank" rel="noopener noreferrer"><i className="school-logo"></i></a>
                            </div>
                            <div className="hd-search-wrap">
                                <button
                                    type="button"
                                    className="is-search"
                                    ref={toggleBtnRef}
                                    onClick={handleSearchToggle}
                                >
                                    검색 열기/닫기
                                </button>

                                <div className="search-box" ref={searchBoxRef}>

                                    <div className="search-area" ref={searchAreaRef}>
                                        <div className="select-wrap">
                                            <select name="" id="category" onChange={handleType}>
                                                <option value="school">학교</option>
                                                <option value="person">인물</option>
                                            </select>
                                        </div>
                                        <div className="input-wrap">
                                            <label htmlFor="search">
                                            <input type="text" name="search" placeholder="검색어 입력" id="search"
                                                    autoComplete="off" value={term} onChange={handleTerm} onKeyDown={onKeyPress}/>
                                            </label>
                                        </div>
                                        <button onClick={handleSearch} className="btn-search">검색</button>
                                    </div>

                                </div>
                            </div>
                            <button className="all-menu hide-pc" onClick={handleOpenAside}>
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>
                        </div>
                    </div>
                </div>
            </header>
            
            <Aside isAsideOpen={isAsideOpen} handleCloseAside={handleCloseAside} />
        </>
    );
}

export default Header;